import React, { useEffect, useState } from "react";
import { db } from "../../../firebaseConfig";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import classes from "./CRPage.module.css";

export default function ViewCR() {
    const [crList, setCrList] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCRs = async () => {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "CR"));
        const crData = [];
        querySnapshot.forEach((docSnap) => {
            crData.push({ id: docSnap.id, ...docSnap.data() });
        });
        setCrList(crData);
        setLoading(false);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this CR?")) {
            await deleteDoc(doc(db, "CR", id));
            fetchCRs();
        }
    };

    useEffect(() => {
        fetchCRs();
    }, []);

    return (
        <div className={classes.container}>
            <h2 className={classes.title}>Class Representatives</h2>
            {loading ? (
                <p>Loading...</p>
            ) : crList.length === 0 ? (
                <p>No CRs found.</p>
            ) : (
                <table className={classes.table}>
                    <thead>
                    <tr>
                        <th>CR Name</th>
                        <th>Roll Number</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {crList.map((cr) => (
                        <tr key={cr.id}>
                            <td>{cr.name}</td>
                            <td>{cr.rollNumber}</td>
                            <td>
                                <button
                                    onClick={() => handleDelete(cr.id)}
                                    className={classes.deleteBtn}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
